import { DatePipe } from '@angular/common';
import {ButtonComponent} from '../shared/action-btns/button.component';
import { CSort } from 'app/shared/constants';

export function columnDefs(datePipe: DatePipe) {
  return [
    {headerName: 'Name', field: 'name', minWidth: 100},
    {headerName: 'Assets', field: 'assetCount', minWidth: 100},
    {headerName: 'User Groups', field: 'userGroupCount', minWidth: 100, hide: true},
    {headerName: 'Created By', field: 'createdBy', sortable: false, minWidth: 100,
      maxWidth: 150, hide: true},
    {headerName: 'Created On', field: 'createdOn', minWidth: 100,
      maxWidth: 170, cellRenderer: (data) => datePipe.transform(data.value,'yyyy-MM-dd')},
    {headerName: 'Edited By', field: 'lastEditedBy', minWidth: 100,
      maxWidth: 170, hide: true},
    {headerName: 'Edited On', field: 'lastEditedOn', minWidth: 100, sort: CSort.DESC,
      maxWidth: 170, cellRenderer: (data) => datePipe.transform(data.value, 'yyyy-MM-dd')},
    {headerName: 'Action', field: 'action', lockVisible: true, sortable: false, cellRendererFramework: ButtonComponent,
      meta: {
        iconType: 'tree',
      }
    }
  ];
}

export const DEFAULT_COL_DEF = {
  minWidth: 100,
  enableValue: false,
  enableRowGroup: false,
  enablePivot: false,
  sortable: true,
  filter: true,
  resizable: true
};

export const SIDEBAR = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
    },
  ],
  position: 'right',
  defaultToolPanel: 'filters',
};

export const TREE_NODE_TYPE = {
  root: 'root',
  group: 'group',
  leaf: 'leaf'
};

export const PERSPECTIVES = [
  {
    'id': '2d4313a3-ac29-4a45-bb76-9109a4d896d6',
    'name': 'p_1',
    'path': '/p_1',
    'type': 'root',
    'assetCount': 20,
    'userGroupCount': 10,
    'userGroups': [],
    'createdOn': '12/12/2012',
    'createdBy': 'Admin',
    'lastEditedBy': 'Admin',
    'lastEditedOn': '12/12/2012',
    'groups': [
      {
        'id': '777db990-8aec-4d53-9366-a1ff9dbc277f4',
        'name': 'g_!',
        'path': '/p_1/g_!',
        'type': 'group',
        'isLatLong': false,
        'groups': [
          {
            'id': '777db990-8aec-4d53-9366-a1ff9dbc277f5',
            'name': 's_g_1',
            'path': '/p_1/g_!/s_g_1',
            'type': 'group',
            'isLatLong': false,
            'groups': [],
            'assets': [
              {
                id: 'id_3',
                name: 'asset_3',
                type: 'asset',
              }
            ]
          }
        ],
        'assets': [
          {
            id: 'id_4',
            name: 'asset_4',
            type: 'asset'
          },
          {
            id: 'id_5',
            name: 'asset_5',
            type: 'asset',
          }
        ],
      },
      {
        'id': '3fced0ae-7672-4aaa-b3ad-a1f498d4e12b',
        'name': 'Group_2',
        'path': '/g_!/Group_2',
        'type': 'group',
        'isLatLong': false,
        'groups': [],
        'assets': [
          {
            id: 'id_6',
            name: 'asset_6',
            type: 'asset',
          },
          {
            id: 'id_7',
            name: 'asset_7',
            type: 'asset',
          }
        ],
      }
    ]
  },
  {
    'id': '3f1bc699-8285-4eea-9d2e-3f3d7e2d61bd',
    'name': 'p_2',
    'path': '/p2',
    'type': 'root',
    'assetCount': 25,
    'userGroupCount': 30,
    'userGroups': [],
    'createdOn': '12/12/2012',
    'createdBy': 'Admin',
    'lastEditedBy': 'Admin',
    'lastEditedOn': '12/12/2012',
    'groups': [
      {
        'id': '777db990-8aec-4d53-9366-a1ff9dbc277f',
        'name': 'g_3',
        'path': '/p_2/g_3',
        'type': 'group',
        'isLatLong': false,
        'groups': [
          {
            'id': '777db990-8aec-4d53-9366-a1ff9dbc277f1',
            'name': 's_g_2',
            'path': '/p_2/g_3/s_g_2',
            'type': 'group',
            'isLatLong': false,
            'groups': [],
            'assets': [
              {
                id: 'id_8',
                name: 'asset_8',
                type: 'asset',
              }
            ]
          }
        ],
        'assets': [
          {
            id: 'id_9',
            name: 'asset_9',
            type: 'asset',
          },
          {
            id: 'id_10',
            name: 'asset_10',
            type: 'asset',
          }
        ],
      },
      {
        'id': '3fced0ae-7672-4aaa-b3ad-a1f498d4e12b3',
        'name': 'g_4',
        'path': '/p_2/g_4',
        'type': 'group',
        'isLatLong': false,
        'groups': [],
        'assets': [
          {
            id: 'id_11',
            name: 'asset_11',
            type: 'asset',
          },
          {
            id: 'id_12',
            name: 'asset_12',
            type: 'asset',
          }
        ],
      }
    ]
  },
  {
    'id': 'bb003fb0-3a6b-4760-b5c6-78078a542fb2',
    'name': 'p_3',
    'path': '/p_3',
    'type': 'root',
    'assetCount': 28,
    'userGroupCount': 15,
    'userGroups': [],
    'createdOn': '12/12/2012',
    'createdBy': 'Admin',
    'lastEditedBy': 'Admin',
    'lastEditedOn': '12/12/2012',
    'groups': [
      {
        'id': '777db990-8aec-4d53-9366-a1ff9dbc277f2',
        'name': 'g_5',
        'path': '/p_3/g_5',
        'type': 'group',
        'isLatLong': false,
        'groups': [
          {
            'id': '777db990-8aec-4d53-9366-a1ff9dbc277f20',
            'name': 's_g_4',
            'path': '/p_3/g_5/s_g_4',
            'type': 'group',
            'isLatLong': false,
            'groups': [],
            'assets': [
              {
                id: 'id_13',
                name: 'asset_13',
                type: 'asset',
              }
            ]
          }
        ],
        'assets': [
          {
            id: 'id_14',
            name: 'asset_14',
            type: 'asset',
          },
          {
            id: 'id_15',
            name: 'asset_15',
            type: 'asset'
          }
        ],
      },
      {
        'id': '3fced0ae-7672-4aaa-b3ad-a1f498d4e12b4',
        'name': 'g_6',
        'path': '/p_3/g_6',
        'type': 'group',
        'isLatLong': false,
        'groups': [],
        'assets': [
          {
            id: 'id_16',
            name: 'asset_16',
            type: 'asset',
          },
          {
            id: 'id_17',
            name: 'asset_17',
            type: 'asset',
          }
        ],
      }
    ]
  }
];
